<app-pagetitle title="Informações do cliente" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>

<div class="row">
  <div class="col-xl-12">
    <div class="card">
        <!-- <div class="card-header">
            <h4 class="card-title">Custom Tabs</h4>
            <p class="card-title-desc">Example of custom tabs.</p>
        </div> -->

        <div class="card-body">
            <!-- Nav tabs -->
            <ul ngbNav #customNav="ngbNav" [activeId]="activeId" class="nav-tabs nav-tabs-custom nav-justified">
                <li [ngbNavItem]="1">
                    <a ngbNavLink>
                        <span class="d-block d-sm-none"><i class="fas fa-home"></i></span>
                        <span class="d-none d-sm-block">Informações Cadastrais</span>
                    </a>
                    <ng-template ngbNavContent>
                        <ng-template [ngTemplateOutlet]="cadastro"></ng-template>
                    </ng-template>
                </li>
                <li [ngbNavItem]="2">
                    <a ngbNavLink>
                        <span class="d-block d-sm-none"><i class="far fa-user"></i></span>
                        <span class="d-none d-sm-block">Projetos</span>
                    </a>
                    <ng-template ngbNavContent>
                        <ng-template [ngTemplateOutlet]="projeto"></ng-template>
                    </ng-template>
                </li>
                <li [ngbNavItem]="3">
                    <a ngbNavLink>
                        <span class="d-block d-sm-none"><i class="far fa-envelope"></i></span>
                        <span class="d-none d-sm-block">Histórico de Mensagens</span>
                    </a>
                    <ng-template ngbNavContent>
                        <ng-template [ngTemplateOutlet]="mensagem"></ng-template>
                    </ng-template>
                </li>
            </ul>
            <div [ngbNavOutlet]="customNav" class="text-muted"></div>
        </div><!-- end card-body -->
    </div><!-- end card -->
</div><!-- end col -->

</div>


<ng-template #cadastro>
  <form class="mb-3" [formGroup]="clientForm" (ngSubmit)="onSubmit()">
    <h2 class="card-title pt-4 pb-3">Cliente</h2>
    <div class="card col-12 mb-4">
      <div class="card-body">
        <div class="row">
          <!-- Name and Email -->
          <div class="col-12 col-md-6 mb-3">
            <div class="form-group">
              <label class="form-label" for="nome">Nome<span class="text-danger" >*</span> </label>
              <input type="text" class="form-control form-control-sm" id="nome" formControlName="nome" [ngClass]="{
                  'is-invalid':
                    clientForm.controls.nome.errors &&
                    clientForm.get('nome')?.touched,
                }" />
              <div class="invalid-feedback" *ngIf="clientForm.get('nome')?.touched && clientForm.get('nome')?.invalid">
                O nome é obrigatório.
              </div>
              <!-- <div class="invalid-feedback" *ngIf="clientForm.controls.nome.errors && clientForm.get('nome')?.touched">
                O nome é obrigatório.
              </div> -->
            </div>
          </div>
          <div class="col-12 col-md-6 mb-3">
            <div class="form-group">
              <label class="form-label" for="contato">Contato</label>
              <input type="text" class="form-control form-control-sm" id="contato" formControlName="contato" [ngClass]="{
                  'is-invalid':
                    clientForm.controls.contato.errors &&
                    clientForm.get('contato')?.touched,
                }" />
              <div class="invalid-feedback" *ngIf="
                  clientForm.controls.contato.errors &&
                  clientForm.get('contato')?.touched
                ">
                O contato é obrigatório.
              </div>
            </div>
          </div>
        </div>
  
        <div class="row">
          <div class="col-12 col-md-6 mb-3">
            <div class="form-group">
              <label class="form-label" for="cnpj">CNPJ <span class="text-danger" >*</span></label>
              <input mask="00.000.000/0000-00" type="text" class="form-control form-control-sm" data-reverse="true"
                placeholder="00.000.000/0000-00" formControlName="cnpj" />
  
              <div style="color:  red;" *ngIf="clientForm.get('cnpj')?.touched && clientForm.get('cnpj')?.errors">
                <small>
                  O CNPJ precisa ter exatamente 14 caracteres.
                </small>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 mb-3">
            <div class="form-group">
              <label class="form-label" for="address">Inscrição Estadual</label>
              <input type="text" class="form-control form-control-sm" id="inscricaoEstadual" formControlName="inscricaoEstadual" />
            </div>
          </div>
        </div>
  
        <div class="row">
          <div class="col-12 col-md-6 mb-3">
            <div class="form-group">
              <label class="form-label" for="email">Email</label>
              <input type="email" class="form-control form-control-sm" id="email" formControlName="email" [ngClass]="{
                  'is-invalid':
                    clientForm.controls.email.errors &&
                    clientForm.get('email')?.touched,
                }" />
              <div class="invalid-feedback" *ngIf="clientForm.controls.email.errors">
                O email é obrigatório e deve ser válido.
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 mb-3">
            <div class="form-group">
              <label class="form-label" for="emailContato">Email contato</label>
              <input type="email" class="form-control form-control-sm" id="emailContato" formControlName="emailContato" [ngClass]="{
                  'is-invalid':
                    clientForm.controls.emailContato.errors &&
                    clientForm.get('emailContato')?.touched,
                }" />
              <div class="invalid-feedback" *ngIf="
                  clientForm.controls.emailContato.errors &&
                  clientForm.get('emailContato')?.touched
                ">
                O email deve ser válido.
              </div>
            </div>
          </div>
        </div>
  
        <!-- Telefone e Ramal -->
        <div class="row">
          <div class="col-12 col-md-6 mb-3">
            <div class="row">
              <div class="col-8">
                <div class="form-group">
                  <label class="form-label" for="telefone">Telefone</label>
                  <input placeholder="(00) 0000-0000" maxlength="13" type="text" class="form-control form-control-sm" id="telefone"
                    formControlName="telefone" />
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label class="form-label" for="ramal">Ramal</label>
                  <input type="text" class="form-control form-control-sm" id="ramal" formControlName="ramal" />
                </div>
              </div>
            </div>
          </div>
  
          <!-- Celular e Ramal Celular -->
          <div class="col-12 col-md-6 mb-3">
            <div class="row">
              <div class="col-8">
                <div class="form-group">
                  <label class="form-label" for="celular">Celular</label>
                  <input type="text" class="form-control form-control-sm" id="celular"
                    formControlName="celular" placeholder="00 00000-0000"/>
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label class="form-label" for="ramalCelular">Ramal</label>
                  <input type="text" class="form-control form-control-sm" id="ramalCelular" formControlName="ramalCelular" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="notes">Anotações</label>
              <textarea class="form-control form-control-sm" maxlength="255" (input)="onInput()" id="anotacao" formControlName="anotacao" rows="4"></textarea>
            </div>
            <small>{{ currentLength }} / 255 caracteres</small>
          </div>
        </div>
      </div>
    </div>
  
    <h4 class="card-title">Endereço</h4>
    <div formGroupName="endereco" class="card col-12 mb-4">
      <div class="card-body">
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="row">
              <div class="col-8">
                <div class="form-group">
                  <label class="form-label" for="rua">Rua</label>
                  <input type="text" class="form-control form-control-sm" id="rua" formControlName="rua" />
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label class="form-label" for="numero">Número</label>
                  <input type="text" class="form-control form-control-sm" id="numero" formControlName="numero" />
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="row">
              <div class="col-12 col-md-6 mb-3">
                <div class="form-group">
                  <label class="form-label" for="bairro">Bairro</label>
                  <input type="text" class="form-control form-control-sm" id="bairro" formControlName="bairro" />
                </div>
              </div>
              <div class="col-12 col-md-6 mb-3">
                <div class="form-group">
                  <label class="form-label" for="cep">CEP</label>
                  <input type="text" class="form-control form-control-sm" id="cep" formControlName="cep" mask="00000-000"
                    placeholder="00000-000" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6 mb-3">
            <div class="form-group">
              <label class="form-label" for="cidade">Cidade</label>
              <input type="text" class="form-control form-control-sm" id="cidade" formControlName="cidade" />
            </div>
          </div>
          <div class="col-12 col-md-6 mb-3">
            <div class="form-group">
              <label class="form-label" for="estado">Estado</label>
              <input type="text" class="form-control form-control-sm" id="estado" formControlName="estado" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="notes">Complemento</label>
              <textarea class="form-control form-control-sm" id="complemento" formControlName="complemento" rows="2"></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <h4 class="card-title">Feiras</h4>
    <div class="card col-12 mb-4">
  
      <div class="card-body">
        <div class="d-flex align-items-center row h-100">
          <div class="col-6">
            <label class="form-label" for="eventId">Feira <span class="text-danger" >*</span></label>
  
            <select class="form-select form-control-sm" id="eventId" formControlName="selectedFeira">
              @for (event of events; track event.id) {
              <option [ngValue]="event">{{ event.nome }}</option>
              }
            </select>
          </div>
          <div class="col-3">
            <label class="form-label" for="metroQuadrado">M² <span class="text-danger" >*</span></label>
            <input type="text" class="form-control form-control-sm" id="metroQuadrado" formControlName="selectedM2" type="number" />
          </div>
          <div class="col-3 align-self-end">
            <button class="btn btn-sm btn-primary" type="button" (click)="addFeira()">
              Adicionar
            </button>
          </div>
        </div>
  
        <div formArrayName="feiras">
          
          <div *ngFor="let feira of feiras.controls; let i = index" [formGroupName]="i">
            <input type="hidden" formControlName="id" />
            <div class="row my-3">
              <div class="col-6">
                <label for="feiraNome">Nome da Feira</label>
                <input id="feiraNome" class="form-control form-control-sm blocked-input" formControlName="nome" />
              </div>
              <div class="col-3">
                <label for="feiraM2">M²</label>
                <input id="feiraM2" class="form-control form-control-sm blocked-input" formControlName="metroQuadrado" />
              </div>
              <div class="col-3">
                <button type="button" class="btn btn-sm btn-info mt-4" title="Editar" (click)="abrirModalEditarFeiraCliente(i)">
                  Editar
                </button>
                <button class="ms-2 btn btn-sm btn-danger mt-4" title="Excluir" (click)="removeFeira(i)">
                  Excluir
                </button>
              </div>
  
  
            </div>
  
          </div>
        </div>
      </div>
    </div>
  
    <div class="d-flex">
      <button (click)="voltar()" type="button" class="btn btn-soft-link waves-effect">Voltar</button>
      <button class="btn btn-sm btn-success" type="submit" [disabled]="loading">
        @if (loading) {
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        } @else {
        Salvar
        }
      </button>
      <button (click)="modalDeletarContato(clientForm.get('id')?.value)" class="btn btn-sm btn-danger ms-2" type="button">
                  Excluir Contato
                </button>
    </div>
  </form>
  
</ng-template>

<!-- Tab Content -->
<ng-template #projeto>
  <app-client-project></app-client-project>
</ng-template>

<ng-template #mensagem>
  <app-client-messages></app-client-messages>
</ng-template>